import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/vendor-preferences/extra-reducer';
import reducers from 'src/redux/vendor-preferences/reducers';
import { vendorPreferencesInitialState } from 'src/redux/vendor-preferences/types';

const vendorPreferencesSlice = createSlice({
  name: 'vendorPreferences',
  initialState: vendorPreferencesInitialState,
  reducers,
  extraReducers,
});

export const {
  setActiveMarket,
  setActiveCategory,
  setActiveSubCategory,
  resetVendorPreferences,
  setConfigError,
  clearError,
} = vendorPreferencesSlice.actions;
export default vendorPreferencesSlice.reducer;
